<template>
  <div class="unit-cost-edit">
    <div class="top">
      <a href="#/ApprovalIndex">
        <img
          src="../assets/images/adidas.png"
          style="width: 160px; height: 37px; margin-top: 10px"
      /></a>
      <a
        href="#/ApprovalIndex"
        style="margin-top: 10px; margin-left: 30px; float: left"
      >
        <img src="../assets/icon/back2.png"
      /></a>
    </div>
    <div class="content_title">
      <div class="title">
        <label>Unit Cost Maintanace</label>
      </div>
      <el-divider></el-divider>
      <div class="editForm">
        <el-form
          ref="editForm"
          :model="form"
          label-width="200px"
          class="clearfix"
          label-position="right"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="Store Format:">
                <el-select
                  placeholder="Please choose"
                  v-model="form.StoreFormat"
                  style="width: 100%"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in formats"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Support Scheme:">
                <el-select
                  placeholder="Please choose"
                  v-model="form.Supporting"
                  style="width: 100%"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in supportSchemes"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
             <el-col :span="8">
              <el-form-item label="Link:">
                 <el-input
                  placeholder="Please enter content"
                  v-model="form.Link"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="FX & MNQ(m2):">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.FxMNQ"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="FX Delivery (POS):">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.FXDelivery"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Local FX(SQM):">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.LocalFX"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="LED(POS):">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.LED"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="LCD(POS):">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.LCD"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="OCS LCD:">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.OCS"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="Gaming area:">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.GamingArea"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Printer:">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.Printer"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Projector:">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.Projector"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="Lighting (m2):">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.Lighting"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Flooring (m2):">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.Flooring"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Local Design (POS):">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.LocalDesign"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="Facade lighting (POS):">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.FacadeLighting"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Ceiling Lighting - Neo Studio:">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.CeilingLighting"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Global Design -  RTC (POS):">
                <el-input
                  placeholder="Please enter content"
                  v-model="form.GlobalDesign"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="save-btn">
        <el-button class="button-search">save</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      channels: ["Core", "Neo", "Originals", "HW", "Kids"],
      subChannels: [
        "Megacourt 200",
        "Neo",
        "Specialty",
        "miniBC",
        "CO",
        "Originals",
        "Basketball",
        "BC",
        "Football",
        "Megacourt 300",
        "Megacourt 600",
        "Running",
        "FTW L1",
        "FTW L2",
        "OD",
        "SWC",
        "SWC L2",
        "Women",
        "HW",
        "Infant",
        "Infant MB",
        "Kids",
        "Kids MB",
        "Core MB",
        "Originals MB",
        "Supercourt 1200",
        "Supercourt 800",
      ],
      formats: [
        "AO",
        "aSE B",
        "aSE B+",
        "aSE C",
        "aSE CO",
        "Basketball",
        "BB MB",
        "BC",
        "BC-Homecourt",
        "Close-out",
        "Collection-A",
        "Collection-CFDD",
        "Core-B",
        "Core-BB",
        "Core-C(1.0)",
        "Core-E",
        "Core-Mega-S",
        "Core-miniBC",
        "Football corner",
        "FTB",
        "FTB MB",
        "FTB MB-HCE",
        "FTB-C",
        "FTW",
        "Halo-BC",
        "HC(2.0)",
        "HCA-B",
        "HCA-C",
        "HC-BB",
        "HC-BB(2.0)",
        "HCE",
        "HCE-BB",
        "HCE-BC",
        "HCE-Football",
        "HCE-MC 300",
        "HCE-MC 600",
        "HCS-MC 600(2.0)",
        "HCS-miniBC",
        "HCS-miniBC(2.0)",
        "HCS-Running",
        "HCS-SWC",
        "HCS-SWC(2.0)",
        "HCS-SWCL2",
        "HCS-SWCL2(2.0)",
        "HCS-TD",
        "HC-SWC",
        "HCS-Women",
        "HC-TD",
        "HC-Women(2.0)",
        "Homecourt-A",
        "Homecourt-B",
        "Homecourt-C",
        "HW-A",
        "HW-B",
        "Infant",
        "Infant CO",
        "Infant-A(1.0)",
        "Infant-A(1.0) Corner",
        "Infant-A(2.0)",
        "Infant-B(1.0)",
        "Infant-B(2.0)",
        "Infant-C(1.0)",
        "Infant-C(2.0)",
        "Infant-Corner",
        "Infant-MB",
        "Kids",
        "Kids CO",
        "Kids MB",
        "Kids3",
        "Kids3-GB",
        "Kids-A",
        "Kids-A(1.0)",
        "Kids-A(2.0)",
        "Kids-A(2.0) Mix",
        "Kids-B",
        "Kids-B(1.0)",
        "Kids-B(2.0)",
        "Kids-C",
        "Kids-C(1.0)",
        "Kids-C(2.0)",
        "Kids-F",
        "Kids-F3",
        "Kids-GB",
        "Kids-HCE",
        "Kids-S POP",
        "Kids-S-A",
        "Kids-S-B",
        "Kids-S-C",
        "Loft-A",
        "Loft-B",
        "Loft-C",
        "Loft-P",
        "Lug MB",
        "MB",
        "MiniBC-HC(2.0)",
        "MT Loft-A",
        "MTN Loft-A",
        "NBA",
        "NBA MB",
        "NBHD",
        "NBHD-CFDD",
        "NBHD-E",
        "NBHD-TD",
        "Neo B",
        "Neo C",
        "Neo CO",
        "Neo Corner",
        "Neo MB",
        "Neo S",
        "Neo S(1.1)",
        "Neo Studio-A",
        "Neo Studio-B",
        "Neo Studio-C",
        "Neo Studio-P",
        "Neo Zone-A",
        "Neo Zone-B",
        "OD MB",
        "OLP",
        "Original Corner",
        "Outdoor",
        "Premium FO",
        "Premium FO-V",
        "Running",
        "Running MB",
        "SC",
        "SC CO",
        "SC MB",
        "SC Neo",
        "SH CO",
        "SH MB",
        "SH2",
        "SH3-B",
        "SH3-B+",
        "SH3-C",
        "SNKRC L1",
        "SNKRC L2",
        "SP1",
        "SP2",
        "SP2L",
        "SP3",
        "SP4",
        "SPC CO",
        "SPC-A",
        "SPC-B(1.0)",
        "SPC-B(2.0)",
        "SPC-B+",
        "SPC-C(1.0)",
        "SPC-C(2.0)",
        "SPC-D",
        "SPC-E",
        "SPR CRT L1(1.0)",
        "SPR CRT L2(1.0)",
        "SPR CRT(1.0)",
        "Stadium POP",
        "Stadium-FO",
        "Studio",
        "Studio-A",
        "Studio-A+",
        "Studio-B",
        "Studio-C",
        "SWC",
        "SWC(2.0)",
        "SWC(2.0)L2",
        "SWC-HC(2.0)",
        "Tennis MB",
        "Terrex",
        "Workshop",
        "Workshop Fashion",
        "Workshop Sports",
        "Workshop-A",
        "Workshop-A+",
        "Workshop-B",
        "Workshop-C",
        "YA",
        "YA-A",
        "YA-A(2.0)",
        "YA-B",
        "YA-B(2.0)",
        "YA-C",
        "YA-C(2.0)",
        "YA-GB",
        "YA-GB(2.0)",
        "Youth",
      ],
      supportSchemes: ["A", "F", "X", "D"],
      form: {
        StoreFormat: "",
        Supporting: "",
        Link: "",
        Format: "",
        LatestModifiedDate: "",
        LatestModifiedBy: "",
        FxMNQ: "",
        LocalFX: "",
        LED: "",
        LCD: "",
        OCS: "",
        GamingArea: "",
        Printer: "",
        Projector: "",
        Lighting: "",
        Flooring: "",
        LocalDesign: "",
        FacadeLighting: "",
        CeilingLighting: "",
        GlobalDesign: "",
      },
    };
  },
  methods: {},
  mounted() {},
};
</script>

<style scoped lang="scss">
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
.cost-filter {
  text-align: left;
  margin-left: 5%;
  margin-top: 10px;
}
.save-btn {
  text-align: center;
  margin-top: 10px;
  .button-search {
    background-color: #e6a23c;
    border: 0px #e6a23c;
    color: #ffff;
  }
}
.content_title {
  margin: 10px auto 0;
  width: 90%;
  text-align: left;
  .title {
    margin-top: 20px;
    margin-bottom: 5px;
    color: #606266;
  }
  .table {
    min-height: 200px;
  }
}
.clearfix:after {
  content: "";
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}
.clearfix {
  zoom: 1;
}
</style>
<style lang="scss">
.editForm {
  .el-form-item__label {
    font-size: 13px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/UnitCostMaintananceEdit.vue